

























































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Workspace, Summary } from '@/entities';
import { AppConstants as _app } from '@/shared/app.constants';
import LeftNavigationComponent from "@/components/App/Modules/GMS/Workspace/Components/LeftNavigation.vue";
import LogFrameComponent from "./Logframework/Logframework.vue";
import NavigationButtons from "@/components/App/Modules/GMS/Workspace/Components/NavigationButtons.vue";
import ProjectMonitoringComponent  from "./Logframework/PMP.vue"
import { MigrationImport } from "@/entities";

const namespace: string = "migration";

@Component({
  components: {
    LeftNavigationComponent,
    LogFrameComponent,
    ProjectMonitoringComponent,
    NavigationButtons
  }
})
export default class LogframeworkComponent extends Vue {
  @State(namespace) appData!: MigrationImport;
  @Getter("indicators", { namespace }) indicators: any;
  @Prop() mapping!: any;
  @Prop() readOnly: boolean;
  @Prop() isDirty!: boolean;
  @Prop() rootSchema: any;
  @Prop() subKey :any;

  logframeKey: number = 0;
  showSideBar = true;
  subSections: any = _app.migrationLogframeworkSections;


  /**mounted function */
  mounted() {
    let selectedsubkey = 'logFramework';          
    this.$emit('subMenuChanged', selectedsubkey );
     if(!this.appData.ImportData.logframework){
        this.appData.ImportData.logframework = [];
    }
  }

  /**  update the sub menu on left panel selection */
  subMenuChanged(selectedMenu, key) {
    this.$emit('subMenuChanged', key);
  }

  get sectionTitle() {
    if(this.subSections && this.subSections.properties && this.subSections.properties[this.subKey])
      return this.subSections.properties[this.subKey].title;
    else
      return '';
  }

  /** change event */
  showChange(e) {
    this.$emit("input", true);
    // console.log('"change" event', e)
  }

  sidebarToggle() {
    this.showSideBar = !this.showSideBar;
  }

  /** watch state and update the variable */
  @Watch("appData")
  onDataChanged(value: any, oldValue: any) {
    if(!this.appData.ImportData.logframework){
        this.appData.ImportData.logframework = [];
    }
    this.logframeKey += 1;
  }

  @Watch("subKey")
  onsubkeyChanged(value: any) {
    this.logframeKey += 1;
    // reset scroll bar to top
    if(this.$refs.logFrame) {
      this.$refs.logFrame["scrollTop"] = 0;
    }
  }
    
}
